import { Badge, Space, Modal, Typography } from "antd";
import {
  CheckCircleOutlined,
  LoadingOutlined,
  RightOutlined,
} from "@ant-design/icons";
import "./RecruitmentQuestionMembershipCard.scss";
import { useEffect, useState } from "react";
import httpclient from "../../../service/httpclient";
import LotterySharePosterModal from "../../../pages/home/lottery/LotterySharePosterModal";
import useLotterySharePoster from "../../../pages/home/lottery/useLotterySharePoster";
import useWindowWidth from "../../../hooks/useWindowWidth";
const { Paragraph } = Typography;
function Description() {
  return (
    <div className="recruitment-question-membership-card-description">
      <div>
        <Space>
          <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
          解锁所有提单
        </Space>
      </div>
      <div>
        <Space>
          <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
          会员模拟考试
        </Space>
      </div>
      <div>
        <Space>
          <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
          秋招新题速达
        </Space>
      </div>
      <div>
        <Space>
          <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
          更多福利...
        </Space>
      </div>
    </div>
  );
}

function RecruitmentQuestionMembershipCard({
  hasMembership,
  hasMembershipRecord,
}) {
  const [productMembership, setProductMembership] = useState(null);
  const [promotionCode, setPromotionCode] = useState("");
  const [lotteryActivity, setLotteryActivity] = useState(undefined);
  const lotterySharePoster = useLotterySharePoster();
  const { windowWidth } = useWindowWidth();
  const showEarlyBirdDiscount =
    !hasMembershipRecord && productMembership?.early_bird_discount > 0;
  const displayPrice =
    hasMembershipRecord && productMembership?.price_12_month
      ? productMembership.price_12_month
      : productMembership?.calculated_price;
  const displayOriginalPrice = hasMembershipRecord
    ? null
    : productMembership?.price;

  useEffect(() => {
    httpclient.getOneProductMembership(1).then((res) => {
      setProductMembership(res);
    });
  }, []);
  useEffect(() => {
    if (!hasMembership) {
      setLotteryActivity(null);
      return;
    }
    httpclient
      .getLotteryCurrent()
      .then((res) => {
        setLotteryActivity(res?.activity || null);
      })
      .catch(() => {
        setLotteryActivity(null);
      });
  }, [hasMembership]);
  useEffect(() => {
    if (!hasMembership) {
      setPromotionCode("");
      return;
    }
    httpclient.getProductMembershipPromoitonCode().then((res) => {
      setPromotionCode(res?.promotion_code);
    });
  }, [hasMembership]);

  if (hasMembership === undefined) return null;

  if (!hasMembership) {
    return (
      <div className="recruitment-question-membership-card">
        <div className="recruitment-question-membership-card-title">
          <b style={{ fontSize: 18, flexShrink: 0 }}>
            题库Pro会员
            {showEarlyBirdDiscount && windowWidth < 899 && (
              <span className="recruitment-question-membership-card-early-bird-tag">
                早鸟价
              </span>
            )}
          </b>
          {productMembership ? (
            <Space style={{ flexShrink: 0 }} align="baseline">
              <span>
                <b style={{ fontSize: 20 }}>
                  ¥{displayPrice / 100}
                </b>
              </span>
              <span>
                {displayOriginalPrice &&
                  displayPrice !== displayOriginalPrice && (
                    <del>¥{displayOriginalPrice / 100}</del>
                  )}
                /年
              </span>
            </Space>
          ) : (
            <LoadingOutlined />
          )}
        </div>

        {showEarlyBirdDiscount && windowWidth >= 899 ? (
          <Badge.Ribbon children={<Description />} text="早鸟价" />
        ) : (
          <Description />
        )}

        <div
          className="recruitment-question-membership-card-button"
          type="primary"
          onClick={() =>
            window.open(
              hasMembershipRecord
                ? "/checkout/product_memberships/1/renew"
                : "/info/product_membership/1",
              "_blank",
              "noopener,noreferrer",
            )
          }
        >
          <b style={{ fontSize: 16 }}>
            <Space>
              {hasMembershipRecord ? "前往续费" : "前往了解"}
              <RightOutlined />
            </Space>
          </b>
        </div>
      </div>
    );
  } else {
    const promotionInvitationCard = (
      <div className="recruitment-question-membership-card">
        <div className="recruitment-question-membership-card-title">
          <b style={{ fontSize: 18, flexShrink: 0 }}>题库Pro会员</b>
          <b>邀请新人加入享优惠</b>
        </div>

        <div
          style={{
            padding: "10px 20px 0 20px",
            color: "rgb(80, 80, 80)",
            fontSize: "14px",
          }}
        >
          好友使用您专属优惠码购买，可以立享70元优惠
          <br />
          好友购买后您将获得专栏半价优惠券一张，专栏50元优惠券各一张
        </div>

        <div
          className="recruitment-question-membership-card-button"
          type="primary"
          onClick={() =>
            Modal.info({
              title: "个人专属优惠码",
              content: (
                <div>
                  <div style={{ display: "flex" }}>
                    优惠码:<Paragraph copyable>{promotionCode}</Paragraph>
                  </div>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "grey",
                      marginTop: "20px",
                    }}
                  >
                    注：请复制优惠码并发送给您的好友，好友在购买时可以输入此优惠码享70元优惠。购买成功后，您可获得专栏半价券一张，专栏50元代金券一张。
                  </div>
                </div>
              ),
              okType: "primary",
              okText: "确定",
            })
          }
        >
          <b style={{ fontSize: 16 }}>
            <Space>
              邀请好友
              <RightOutlined />
            </Space>
          </b>
        </div>
      </div>
    );

    if (lotteryActivity) {
      return (
        <>
          <div className="recruitment-question-membership-card recruitment-question-membership-card-lottery">
            <div className="recruitment-question-membership-card-title">
              <b style={{ fontSize: 18, flexShrink: 0 }}>题库Pro会员</b>
              <b>邀请好友赢抽奖机会</b>
            </div>

            <div className="recruitment-question-membership-card-lottery-copy">
              好友通过你的海报进入题库页并新购题库 Pro 会员，你可额外获得 1 次今日抽奖机会。
              <br />
              购买奖励不设上限，今日获得的次数将在明日刷新。
            </div>

            <div
              className="recruitment-question-membership-card-button"
              type="primary"
              onClick={lotterySharePoster.open}
            >
              <b style={{ fontSize: 16 }}>
                <Space>
                  {lotterySharePoster.loading ? "海报生成中" : "生成邀请海报"}
                  <RightOutlined />
                </Space>
              </b>
            </div>
          </div>
          {!!lotterySharePoster.poster && (
            <LotterySharePosterModal
              posterPreview={lotterySharePoster.posterPreview}
              subtitle="好友扫码进入题库页，成功新购题库 Pro 会员后，你可额外获得 1 次今日抽奖机会。"
              onClose={lotterySharePoster.close}
              onCopyLink={lotterySharePoster.copyLink}
              onDownload={lotterySharePoster.download}
            />
          )}
          {promotionInvitationCard}
        </>
      );
    }

    return promotionInvitationCard;
  }
}

export default RecruitmentQuestionMembershipCard;
